import * as DuotoneIcons from '@fortawesome/pro-duotone-svg-icons';
import * as RegularIcons from '@fortawesome/pro-regular-svg-icons';

type IconPackage = 'duotone' | 'regular';

const ICON_PACKAGES = {
  duotone: DuotoneIcons,
  regular: RegularIcons,
} as const;

const toPascalCase = (str: string) => {
  return str
    .split(/[-_\s]+/)
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1).toLowerCase())
    .join('');
};

export const getIconDefinition = (iconName: string, packageType: IconPackage = 'duotone') => {
  const iconPackage = ICON_PACKAGES[packageType];

  const exact = (iconPackage as any)[iconName];
  if (exact) {
    return exact;
  }

  const pascalCaseName = toPascalCase(iconName);
  const prefixedName = 'fa' + pascalCaseName;
  const possible = (iconPackage as any)[prefixedName];
  if (possible) {
    return possible;
  }

  return null;
};
